import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from '~/modules/auth/context/AuthProvider';

import { findOneProject } from '../apis';

export const FIND_ONE_PROJECT_QUERY_KEY = 'findOneProject';

export const useFindOneProject = (projectId: string) => {
  const { userInfo } = useAuthContext();

  const query = useQuery({
    queryKey: [FIND_ONE_PROJECT_QUERY_KEY, projectId, userInfo?._id],
    queryFn: async () => {
      const { data } = await findOneProject(projectId);
      return data;
    },
    /**
     * 1분 이내에 prefetch된 데이터가 있을 경우 fetch하지 않음
     */
    staleTime: 1000 * 60, // 1분
  });

  return query;
};
